import type { RouteRecordRaw } from 'vue-router'

const officeCertificatesRoutes: RouteRecordRaw[] = [
  {
    path: '/office/certificates',
    name: 'office-certificates.index',
    component: () =>
      import('@/modules/office/office-certificates/views/OfficeCertificatesIndex.vue'),
    meta: {
      pageTitle: 'Office certificates',
      breadcrumbs: ['Office certificates']
    }
  },
  {
    path: '/office/certificates/create',
    name: 'office-certificates.create',
    component: () =>
      import('@/modules/office/office-certificates/views/OfficeCertificatesEdit.vue'),
    meta: {
      pageTitle: 'Office certificates',
      breadcrumbs: ['Office certificates']
    }
  },
  {
    path: '/office/certificates/:id',
    name: 'office-certificates.show',
    component: () =>
      import('@/modules/office/office-certificates/views/OfficeCertificatesShow.vue'),
    meta: {
      pageTitle: 'Office certificates',
      breadcrumbs: ['Office certificates']
    }
  },
  {
    path: '/office/certificates/:id/edit',
    name: 'office-certificates.edit',
    component: () =>
      import('@/modules/office/office-certificates/views/OfficeCertificatesEdit.vue'),
    meta: {
      pageTitle: 'Office certificates',
      breadcrumbs: ['Office certificates']
    }
  }
]

export default officeCertificatesRoutes
